export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/uk.lyaml"));
at({ "uk": { "public": { "sampleString": "\u041F\u0440\u0438\u043A\u043B\u0430\u0434 \u0440\u044F\u0434\u043A\u0430" } } });
};